import layout from 'src/modules/layout/layoutReducers';
import auth from 'src/modules/auth/authReducers';
import tenant from 'src/modules/tenant/tenantReducers';
import user from 'src/modules/user/userReducers';
import auditLog from 'src/modules/auditLog/auditLogReducers';
import settings from 'src/modules/settings/settingsReducers';
import eLabel from 'src/modules/eLabel/eLabelReducers';
import producer from 'src/modules/producer/producerReducers';
import nutritionInformation from 'src/modules/nutritionInformation/nutritionInformationReducers';
import image from 'src/modules/image/imageReducers';
import sustainability from 'src/modules/sustainability/sustainabilityReducers';
import packagingCertification from 'src/modules/packagingCertification/packagingCertificationReducers';
import recyclingMaterials from 'src/modules/recyclingMaterials/recyclingMaterialsReducers';
import responsibleConsumption from 'src/modules/responsibleConsumption/responsibleConsumptionReducers';
import foodOperator from 'src/modules/foodOperator/foodOperatorReducers';
import { combineReducers } from 'redux';
import plan from 'src/modules/plan/planReducers';

export default () =>
  combineReducers({
    layout,
    auth,
    tenant,
    plan,
    user,
    auditLog,
    settings,
    eLabel,
    producer,
    nutritionInformation,
    image,
    sustainability,
    packagingCertification,
    recyclingMaterials,
    responsibleConsumption,
    foodOperator,
  });
